<fieldset [formGroup]="signatureForm" *ngrxLet="signature$; let signature">
    <div class="row mb-3">
        <div class="col">
            <p>{{ signature.description }}</p>
        </div>
    </div>
    <div class="row mb-3">
        <span class="col-md-2 col-form-label col-4 text-start">{{ signature.label }}</span>
        <div class="col-md-auto col-12">
            <canvas
                #signatureCanvas
                class="cse-signature-canvas signature-canvas"
                [ngClass]="{
                    'ng-invalid': !signaturePad || (signaturePad.isEmpty && firstNameControl.enabled),
                    disabled: firstNameControl.disabled,
                }"
            ></canvas>
        </div>
        <div class="col-md-auto col-6 pt-md-0 pt-3">
            <button
                type="button"
                class="btn btn-secondary btn-lg"
                (click)="clearSignature()"
                [disabled]="signature.disabled || (readOnly$ | async)"
                translate="F4M_SUMMARY_MODAL_CLEAR_LABEL"
            ></button>
        </div>
        <div class="col-md-auto col-4 pt-md-0 pt-4 ps-2" *ngIf="displayNACheckboxForCustomerSignature$ | async">
            <div class="not-applicable">
                <div class="checkbox-container">
                    <input
                        type="checkbox"
                        class="form-control"
                        id="system-condition-signature-not-application"
                        #checkbox
                        [formControl]="checkboxControl"
                    />
                    <fa-icon *ngIf="checkbox.checked" [icon]="faCheck" size="2x" (click)="checkbox.click()"></fa-icon>
                </div>
                <label translate="F4M_NOT_APPLICABLE_LABEL" for="system-condition-signature-not-application"></label>
            </div>
        </div>
        @if (displayHistoryButton$ | async) {
            <div class="col-auto pt-sm-0 pt-4 ms-auto d-flex align-items-center">
                <pace-forms-history-button [uniqueId]="signature.uniqueId"></pace-forms-history-button>
            </div>
        }
    </div>
    <div class="row mb-3">
        <label
            class="col-md-2 col-4 text-start col-form-label"
            for="{{ signature.nameXmlId }}-firstName"
            translate="SYSTEM_CONDITION_SIGNATURE_FIRST_NAME_LABEL"
        ></label>
        <div class="col-md-10 col-12">
            <input
                type="text"
                class="form-control input-md name-input"
                id="{{ signature.nameXmlId }}-firstName"
                [formControl]="firstNameControl"
            />
        </div>
    </div>
    <div class="row mb-3">
        <label
            class="col-md-2 col-4 col-form-label text-start"
            for="{{ signature.nameXmlId }}-lastName"
            translate="SYSTEM_CONDITION_SIGNATURE_LAST_NAME_LABEL"
        ></label>
        <div class="col-md-10 col-12">
            <input
                type="text"
                class="form-control input-md name-input"
                id="{{ signature.nameXmlId }}-lastName"
                [formControl]="lastNameControl"
            />
        </div>
    </div>
</fieldset>
